import {CartAssetActionLabel} from '../locales';
import {canAddAssetToCart, canRemoveAssetFromCart} from '../enablers';

import type {Action} from '@netx/core/bootstrap';

import {icon} from '@fortawesome/fontawesome-svg-core';
import {faInboxIn, faInboxOut} from '@netx/core-icons';

const iconOpts = {classes: ['fa-fw']};
const icons = {
	faInboxIn: icon(faInboxIn, iconOpts).html,
	faInboxOut: icon(faInboxOut, iconOpts).html,
};

export const CART_ASSET_ACTION_ICON = <const>{
	ADD_TO_CART: faInboxIn,
	REMOVE_FROM_CART: faInboxOut,
};

export type CartAssetBaseVent = typeof CART_ASSET_BASE_EVENT;

export const CART_ASSET_BASE_EVENT = `cart:asset`;

export const CART_ASSET_EVENT = <const>{
	ADD_TO_CART: `${CART_ASSET_BASE_EVENT}:add`,
	REMOVE_FROM_CART: `${CART_ASSET_BASE_EVENT}:remove`,
};

export const CART_ASSET_ACTIONS: Action<
	(typeof CART_ASSET_EVENT)[keyof typeof CART_ASSET_EVENT]
>[] = [
	{
		event: CART_ASSET_EVENT.ADD_TO_CART,
		enableTest: canAddAssetToCart,
		icon: icons.faInboxIn,
		get label() {
			return CartAssetActionLabel.ADD_TO_CART;
		},
	},
	{
		event: CART_ASSET_EVENT.REMOVE_FROM_CART,
		enableTest: canRemoveAssetFromCart,
		icon: icons.faInboxOut,
		get label() {
			return CartAssetActionLabel.REMOVE_FROM_CART;
		},
	},
];

export default CART_ASSET_ACTIONS;
